import React, { useState } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { API_URL } from '../config';
import axiosInstance from './AxiosInstance';



export const loginUser = (username, password) => {
   
    return axios.post(`${API_URL}/login`, { username, password });

};
export const fetchData = async () => {
    const token = localStorage.getItem('token');
    console.log('test1')
    return await axios.get(`${API_URL}/secure`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

export const fetchBrand = () => {
    const token = localStorage.getItem('token');
    console.log('test')
    return axios.get(`${API_URL}/getallbrands`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};
export const fetchModel = () => {
    const token = localStorage.getItem('token');
    console.log('test')
    return axios.get(`${API_URL}/getallmodels`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};



export const fetchBodyType = () => {
    const token = localStorage.getItem('token');
    console.log('test')
    return axios.get(`${API_URL}/getallbodytype`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};
export const fetchEngineClass = () => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/getallengine`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};



export const CreateBrand = async (b, file) => {   
    const formData = new FormData();
    formData.append('brand', JSON.stringify(b));
   // formData.append("brand", b); // Assuming `brandData` has your brand details
    formData.append("file", file);
    return await axiosInstance.post(`${API_URL}/createbrand`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const CreateBody = async (a) => {

    return await axiosInstance.post(`${API_URL}/createbodytype`, a
       
        );
};

export const CreateEngine = async (u) => {

    return await axiosInstance.post(`${API_URL}/createengineclass`, u
        
        );
};
export const CreateModel = async (a) => {

    return await axiosInstance.post(`${API_URL}/createmodel`, a
        );
};
export const DeleteBrands = async (a) => {

    return await axios.get(`${API_URL}/deletebrand`, {
        params: {
            id: a
        },
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer your-access-token' // Optional, for authentication
        }
    });
};
export const UpdateBrands = async (updatedData) => {

    return await axios.post(`${API_URL}/updatebrand`, updatedData, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer your-access-token' // Optional, for authentication
        }
    });
};

export const UpdatedModels = async (updatedData) => {

    return await axios.post(`${API_URL}/updatemodel`, updatedData, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer your-access-token' // Optional, for authentication
        }
    })
};

export const UpdateCarBody = async (updatedData) => {

    return await axios.post(`${API_URL}/updatebodytype`, updatedData, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer your-access-token' // Optional, for authentication
        }
    });
};
export const updateServiceCategory1 = async (updatedData) => {

    return await axios.post(`${API_URL}/updateserviceCategory`, updatedData, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer your-access-token' // Optional, for authentication
        }
    });
};
export const updateServiceCategory = async (b,id, file) => {
    const formData = new FormData();
    const payload = typeof b === 'string'
        ? { name: b, showInCustomerApp: true, isActive: true }
        : b;
    formData.append('ServiceCategory', JSON.stringify(payload));
    formData.append('Id', JSON.stringify(id));
    // formData.append("brand", b); // Assuming `brandData` has your brand details
    formData.append("file", file);


    return await axios.post(`${API_URL}/updateserviceCategory`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const updateAdditionalService = async (updatedData) => {

    return await axios.post(`${API_URL}/updateadditionalservice`, updatedData, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer your-access-token' // Optional, for authentication
        }
    });
};

export const fetchServiceCategory = () => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/getallServiceCategory`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};
export const fetchAdditionalService = () => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/getallAdditionalServices`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};
export const fetchPartner = () => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/getallpartners`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};

export const CreatePartner= async (b, file,iconFile) => {  
 
    const formData = new FormData();
    formData.append('partner', JSON.stringify(b));
   // formData.append("brand", b); // Assuming `brandData` has your brand details
    formData.append("Doc", file);
    formData.append("Icon", iconFile[0]);
    return await axiosInstance.post(`${API_URL}/createpartner`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const DeleteBody = async (b) => {

    return await axios.get(`${API_URL}/deletebodytype`, {
        params: {
            id: b
        },
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer your-access-token' // Optional, for authentication
        }
    })
};

export const DeleteModels = async (c) => {

    return await axios.get(`${API_URL}/deletemodel`, {
        params: {
            id: c
        },
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer your-access-token' // Optional, for authentication
        }
    })
};


export const DeleteEngine = async (d) => {

    return await axios.get(`${API_URL}/deleteengineclass`, {
        params: {
            id: d
        },
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer your-access-token' // Optional, for authentication
        }
    })
};

export const deleteServiceCategory = async (d) => {

    return await axios.get(`${API_URL}/deleteservicecategory`, {
        params: {
            id: d
        },
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer your-access-token' // Optional, for authentication
        }
    })
};
export const deleteServiceById = async (d) => {

    return await axios.get(`${API_URL}/deleteservice`, {
        params: {
            id: d
        },
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer your-access-token' // Optional, for authentication
        }
    })
};
export const deleteAdditionalService = async (d) => {

    return await axios.get(`${API_URL}/deleteadditionalservice`, {
        params: {
            id: d
        },
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer your-access-token' // Optional, for authentication
        }
    })
};


export const UpdateEngine = async (updatedData) => {

    return await axios.post(`${API_URL}/updateengineclass`, updatedData, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer your-access-token' // Optional, for authentication
        }
    });
};

export const CreateServiceCategory = async (b, file) => {
    const formData = new FormData();
    formData.append('ServiceCategory', JSON.stringify(b));
    // formData.append("brand", b); // Assuming `brandData` has your brand details
    formData.append("file", file);
  

    return await axios.post(`${API_URL}/CreateServiceCategory`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const CreateServiceByAdmin = async (service, file) => {
    const formData = new FormData();
    formData.append('service', JSON.stringify(service));
    if (file) {
        formData.append('file', file);
    }
    return await axiosInstance.post(`${API_URL}/createServiceByAdmin`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
};

export const CreateAdditionalService = async (b) => {

    return await axios.post(`${API_URL}/Createadditionalservice`, b
        , {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer your-access-token' // Optional, for authentication
            }
        });
};
export const validateToken = async (token) => {
    return await axios.get(`${API_URL}/activate/${token}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer your-access-token' // Optional, for authentication
            }
        });
    
};
export const generatePassword = async (UserID, Password) => {
    try {
      
        const response = await axios.post(`${API_URL}/generatepassword/${UserID}/${Password}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer your-access-token' // Optional, for authentication
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error activating partner:", error);
        throw error;
    }
};

export const getAdminDashboard = () => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/dashboard`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};
export const getProfile = async () => {
    const token = localStorage.getItem('token');

    try {
        const response = await axiosInstance.get(`${API_URL}/userdetails`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response; // Return the actual data from the response
    } catch (error) {
        if (error.response && error.response.status === 401) {
            console.error("Unauthorized: Redirecting to login.");
            // Clear token and redirect to login
            localStorage.removeItem('token');
            window.location.href = '/login'; // Update the redirect URL as needed
        } else {
            console.error("An error occurred:", error);
        }
        throw error; // Re-throw the error to handle it upstream if necessary
    }
};
export const getOrders = () => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/allorders`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};
export const getPartnerOrders = () => {
   
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/allordersbypartner`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};
export const getOrderDetails = (id) => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/order/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};
export const setFeaturedService = (id,isfeaured) => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/setservicefeatured/${id}/${isfeaured}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};
export const FetchTranslations = (lang) => {   
    return axios.get(`${API_URL}/gettranslation/${lang}`, {
       
    })
};
export const getAllProductCategories = () => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/getallproductcategories`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
};

export const createProductCategory = async (productCategory) => {
    const token = localStorage.getItem('token');
    return await axios.post(`${API_URL}/createproductcategory`, productCategory,
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
};

export const updateProductCategory = async (productCategory) => {
    const token = localStorage.getItem('token');
    return await axios.post(`${API_URL}/updateproductcategory`, productCategory,
        {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
};

export const deleteProductCategoryById = async (id) => {
    const token = localStorage.getItem('token');
    return await axios.delete(`${API_URL}/deleteproductcategory/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};
export const DeleteCoupon = async (id) => {
    const token = localStorage.getItem('token');
    return await axios.delete(`${API_URL}/deletecoupon/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

// Checklist API functions
export const getAllChecklists = () => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/checklists`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

export const getChecklistsByServiceCategoryId = (serviceCategoryId) => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/checklists/service-category/${serviceCategoryId}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

export const getChecklistById = (id) => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/checklist/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

export const createChecklist = async (checklist) => {
    const token = localStorage.getItem('token');
    return await axios.post(`${API_URL}/checklist`, checklist, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });
};

export const updateChecklist = async (id, checklist) => {
    const token = localStorage.getItem('token');
    return await axios.put(`${API_URL}/checklist/${id}`, checklist, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });
};

export const deleteChecklist = async (id) => {
    const token = localStorage.getItem('token');
    return await axios.delete(`${API_URL}/checklist/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

export const toggleChecklistStatus = async (id) => {
    const token = localStorage.getItem('token');
    return await axios.post(`${API_URL}/checklist/${id}/toggle-status`, {}, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};


export const UpdateCouponStataus = async (id,status) => {
    const token = localStorage.getItem('token');
    return await axios.get(`${API_URL}/updatecouponstatus/${id}/${status}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
};

export const testEmail = async (emailData) => {
    const token = localStorage.getItem('token');
    return await axiosInstance.post(`${API_URL}/testemail`, emailData, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    });
};

